import { ListViewModel, ListViewModelImpl } from '../../horizontallist/listviewmodel';
import { BaseContext } from '../../../../utils/basecontext';
import { GridPaginationComponentState } from './gridpaginationcomponent';

export interface GridPaginationListViewModel<T> extends ListViewModel<T>
{
    getTotalCount(): number;
    getOffset(): number;
    resetPaginationState(): void;
    getPaginationState(): GridPaginationComponentState;
}

export class GridPaginationListViewModelImpl<T> extends ListViewModelImpl<T> implements GridPaginationListViewModel<T>
{
    private totalCount: number = 0;
    private offset: number = 0;
    private gridPaginationComponentState: GridPaginationComponentState;

    constructor(offset: string, context: BaseContext)
    {
        super(context);

        this.setOffSet(+offset);

       this.resetPaginationState();
    }

    setPaginationState(gridPaginationComponentState: GridPaginationComponentState)
    {
        this.gridPaginationComponentState = gridPaginationComponentState;
    }

    getPaginationState(): GridPaginationComponentState
    {
        return this.gridPaginationComponentState;
    }

    setOffSet(offset: number)
    {
        this.offset = offset;
    }

    setTotalCount(totalCount: number)
    {
        this.totalCount = totalCount;
    }

    getTotalCount(): number 
    {
        return this.totalCount;
    }

    resetPaginationState()
    {
        console.log("-----length: " + this.getListOfDatas().length);
        this.gridPaginationComponentState = {currentPageNo: 1, startIndex: 0, isLeftArrowEnabled: false, 
            isRightArrowEnabled: this.getListOfDatas().length >= this.getOffset() ? true : false, arrowSelected: "right"};
    }

    getOffset(): number {
       return this.offset;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/grid/gridpagination/gridpaginationlistviewmodel.ts